<template>
  <div class="admin-bulk-pages-creator">
    <PageHeader>
      <div class="heading">
        <h1>
          <router-link :to="{name: 'admin-actions'}">Admin Actions</router-link>
          / <strong class="name">Bulk Page Creator</strong>
        </h1>
      </div>
    </PageHeader>

    <div class="page-columns">
      <div class="col main">
        <div class="page-content admin-pages">
          <div class="admin-pages-form">
            <transition name="fade">
              <BulkPageCreatorForm
                v-if="!jobCompleted"
                v-model="job"
                :companies="companies"
                :websites="websites"
                @submit="startJob"
                :errors="errors"
              />

              <div v-else>
                <h2>All Pages Added!</h2>
                <router-link
                  :to="{
                    name: 'pages',
                    params: {
                      companyId: job.companyId,
                      siteId: job.siteId
                    }
                  }"
                  class="btn is-primary"
                >
                  View Pages
                </router-link>
              </div>
            </transition>
          </div>
        </div>
      </div>

      <div class="col side">
        <PageSummary>
          <div>
            <h1>Bulk Page Creator</h1>
            <p>
              Many customers require "Location" pages on their websites. This
              action will quickly create pages in bulk.
            </p>
          </div>
        </PageSummary>
      </div>
    </div>
  </div>
</template>

<script>
import BulkPageCreatorForm from '@/components/forms/BulkPageCreatorForm'
import PageHeader from '@/components/PageHeader'
import PageSummary from '@/components/PageSummary'

import page from '@/mixins/page'

import {readCompaniesData} from '@/lib/companies'
import {readCompanySitesData} from '@/lib/sites'
import {createCompanySitePageData} from '@/lib/pages'

import {createCompanySitePageListData} from '@/lib/lists'
import {createCompanySitePageListListItemData} from '@/lib/list_items'
import {readListTypesData} from '@/lib/list_types'

export default {
  name: 'AdminWebsite',

  mixins: [page],

  data() {
    return {
      jobCompleted: false,
      job: {
        pageNames:
          'Web developer in Redhill\nWeb developer in Reigate\nWeb developer in Crawley'
      },
      errors: {},
      logs: ['Ready...'],
      title: 'Bulk Page Creator',
      companies: [],
      websites: [],
      page: {page: 1, page_size: 500}
    }
  },

  components: {
    BulkPageCreatorForm,
    PageHeader,
    PageSummary
  },

  computed: {
    slideshowType() {
      return this.listTypes.find((type) => type.name === 'slideshow')
    }
  },

  methods: {
    getData() {
      readListTypesData().then(({data}) => {
        this.listTypes = data
      })

      readCompaniesData(this.page).then(({data}) => {
        data.forEach((company) => {
          this.companies.push({
            key: company.name,
            value: company.id
          })
        })
      })
    },

    getCompanySites() {
      readCompanySitesData(this.job.companyId, this.page).then(({data}) => {
        this.websites = []

        data.forEach((site) => {
          this.websites.push({
            key: site.name,
            value: site.id
          })
        })
      })
    },

    startJob() {
      this.createSitePages()
    },

    createSitePages() {
      let pages = this.job.pageNames.split('\n')

      pages.forEach((page, index) => {
        let path = page.replace(/\s+/g, '-').toLowerCase()

        let pageData = {
          name: page,
          path: `/${path}`,
          show_in_menu: false,
          title: page,
          preview_image: this.job.pageImage,
          menu_weight: 100 + index
        }

        createCompanySitePageData(
          this.job.companyId,
          this.job.siteId,
          pageData
        ).then(({data}) => {
          let createdPage = data
          this.createPageSlideshow(createdPage)
        })
      })
    },

    createPageSlideshow(page) {
      let list = {
        name: 'Page Banner',
        list_type_id: this.slideshowType.id,
        weight: 1
      }

      createCompanySitePageListData(
        this.job.companyId,
        this.job.siteId,
        page.id,
        list
      )
        .then(({data}) => {
          let createdList = data
          this.createdListId = data.id

          this.logs.push(`Successfully created '${createdList.name}'`)

          let listItem = {
            key: 'Slide 1',
            value: `{"heading": "${page.name}", "image_url": "${this.job.pageImage}", "slide_height": "100vh"}`,
            weight: 1
          }

          this.createPageListListItem(page.id, createdList, listItem)

          this.completeJob()
        })
        .catch(({response}) => {
          this.logs.push(response)
        })
    },

    createPageListListItem(pageId, createdList, listItem) {
      createCompanySitePageListListItemData(
        this.job.companyId,
        this.job.siteId,
        pageId,
        createdList.id,
        listItem
      )
        .then(({data}) => {
          let listItem = data
          this.logs.push(`Successfully created list item ${listItem.key}`)
        })
        .catch(({response}) => {
          this.errors = response.errors
        })
    },

    completeJob() {
      this.jobCompleted = true
    }
  },

  mounted() {
    this.getData()
  },

  watch: {
    'job.companyId'() {
      this.getCompanySites()
    }
  }
}
</script>
